function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 3,
  fill: "#005646"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.226 10.967s1.833.249 2.88-.934c1.048-1.182.885-3.702.885-3.702s-2.129-.345-3.08.773c-.298.35-.685.772-.685 1.931v1.932zm0 0s-2.395.386-4.046-1.477C2.529 7.626 3.093 4.014 3.093 4.014s2.5-.27 4.147 1.59c.662.747.986 1.886.986 3.204v2.159zm1.711-1.932l-1.71 1.546M5.488 7.49l2.588 3.068",
  stroke: "#fff"
});

function SvgGreen2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgGreen2;